<template>
  <div class="register-agreement">
    <el-checkbox v-model="agreed">
      <span class="register-agreement__text">
        我已阅读并同意
        <a class="register-agreement__link" href="#" @click.prevent="openPolicy(POLICY_TYPE.USER_AGREEMENT)">《用户注册协议》</a>、
        <a class="register-agreement__link" href="#" @click.prevent="openPolicy(POLICY_TYPE.PLATFORM_AGREEMENT)">《平台协议》</a>、
        <a class="register-agreement__link" href="#" @click.prevent="openPolicy(POLICY_TYPE.USAGE_AGREEMENT)">《使用协议》</a>
      </span>
    </el-checkbox>
  </div>
</template>

<script>
import { POLICY_TYPE } from '@/utils/policyTypes'

export default {
  name: 'RegisterAgreement',
  data() {
    return {
      agreed: false,
      POLICY_TYPE
    }
  },
  methods: {
    validate() {
      if (!this.agreed) {
        this.$message.warning('请先阅读并同意用户注册协议、平台协议及使用协议')
        return false
      }
      return true
    },
    openPolicy(type) {
      const route = this.$router.resolve({
        path: '/profile/rechargePolicy',
        query: { type: String(type) }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.register-agreement {
  margin: 12px 0 4px;
  line-height: 1.5;

  ::v-deep .el-checkbox__label {
    white-space: normal;
    line-height: 1.5;
    font-size: 13px;
    color: #606266;
  }

  &__text {
    display: inline;
  }

  &__link {
    color: #0f6fe2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
